module.exports = __webpack_public_path__ + "img/code-circle-03.5e5d6f8d.svg";